if (!customElements.get('review-stars')) {
  class ReviewStars extends HTMLElement {
    constructor() {
      super()

      this.fetchReviews()
    }

    render(data) {
      const $countValue = this.querySelector('[data-count] .count-value')
      const $countContainer = this.querySelector('[data-count]')
      if ($countValue && $countContainer) {
        $countValue.textContent = data.count
        // Hide parentheses if no reviews
        $countContainer.style.display = data.count > 0 ? 'inline' : 'none'
      }

      const $rating = this.querySelector('[data-rating]')
      if ($rating) $rating.textContent = data.rating

      const ratingPercent = (data.rating / 5) * 100
      const $stars = this.querySelector('svg:nth-child(2)')
      if ($stars) $stars.style.clipPath = `polygon(0 0, ${ratingPercent}% 0, ${ratingPercent}% 100%, 0 100%)`
    }

    fetchReviews() {
      const productId = this.getAttribute('product-id')
      const storageKey = `reviews-stars:${productId}`

      const cachedReviews = sessionStorage.getItem(storageKey)
      if (cachedReviews) {
        const data = JSON.parse(cachedReviews)
        this.render(data)
        return
      }

      const okendoUserId = '670e0dce-bb70-4eb8-85cd-20b14afef5f0'
      const url = `https://api.okendo.io/v1/stores/${okendoUserId}/products/shopify-${productId}/review_aggregate`

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            data.reviewAggregate &&
            data.reviewAggregate.reviewCount !== undefined &&
            data.reviewAggregate.ratingAndReviewValuesTotal !== undefined
          ) {
            const max5Stars = 5 * data.reviewAggregate.reviewCount
            const ratingPercent = data.reviewAggregate.ratingAndReviewValuesTotal / max5Stars
            const rating = 5 * ratingPercent
            const _data = {
              count: data.reviewAggregate.reviewCount,
              rating: Number.parseFloat(rating.toFixed(1)),
            }
            this.render(_data)
            // Cache the data
            sessionStorage.setItem(storageKey, JSON.stringify(_data))
          }
        })
        .catch((error) => {
          console.error('Error fetching Okendo reviews:', error)
        })
    }
  }

  customElements.define('review-stars', ReviewStars)
}
